export class Vaccination {
  dt?: string;
  firstname?: string;
  patient_id?: number;
  description?: string;
  brand_name?: string;
  version_id?: number;
  vaccination_date?: string;
  brand_name_id?: string;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
